import { render, staticRenderFns } from "./copasst.vue?vue&type=template&id=32a3b7a8&"
import script from "./copasst.vue?vue&type=script&lang=js&"
export * from "./copasst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports